<template>
    <div>
       <template v-for="(item, rowIndex) in columnsPerRow" >
               <v-row v-bind:key="rowIndex">
                   <template  v-for="(columnItem) in columnsPerRow[rowIndex]">                   
                      <v-col v-bind:key="columnItem.index">
                          <template v-for="item in columnItem.controls">                         
                             <template v-if="item.code.toUpperCase() === 'GROUP' || item.code.toUpperCase() === 'SOURCE'">
                               <div v-bind:key="item.code" :class="{ 'is-invisible': !item.visibleFlag }">                                 
                                   <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                    <v-select
                                       v-model="getCopyControl(item).selectedValues"
                                       :items="item.availableValues"
                                       item-text="label" 
                                       item-value="value"                              
                                       multiple
                                       outlined
                                       dense
                                       :rules="[v=> !item.requiredFlag || (!!v || '')]"    
                                    >                                  
                                    </v-select>             
                                   
                                </div>
                            </template>
                            <template v-if="item.htmlControlType.toUpperCase() === 'DROPDOWN'">
                                <div v-bind:key="item.code" v-if="item.code !== 'EMAILTYPE' 
                                      && item.code !== 'PHONETYPE' 
                                      && item.code !== 'SOCIALACCOUNTTYPE' 
                                      && item.code !== 'LEADOWNER'" :class="{ 'is-invisible': !item.visibleFlag }">
                                      <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                      <v-select           
                                       :id="item.code"                          
                                       v-model="getCopyControl(item).selectedValues[0]"
                                       :items="item.availableValues"                            
                                       item-text="label" 
                                       item-value="value"                                
                                       outlined
                                       dense 
                                       :rules="[v=> !item.requiredFlag || (!!v || '')]"
                                       >                                     
                                    </v-select>                         
                                
                                </div>                 
                            </template>
                            <template v-if="item.htmlControlType.toUpperCase() === 'MULTISELECT' && item.code.toUpperCase() !== 'GROUP' && item.code.toUpperCase() !== 'SOURCE'">
                                <div v-bind:key="item.code" :class="{ 'is-invisible': !item.visibleFlag }">  
                                      <label :class="{'required':item.requiredFlag}">{{item.name}}</label>                                
                                      <v-select                                      
                                       v-model="getCopyControl(item).selectedValues"
                                       :items="item.availableValues"                            
                                       item-text="label" item-value="value"  
                                       multiple
                                       outlined
                                       dense  
                                       :rules="[v=> !item.requiredFlag || (item.selectedValues.filter(x=>x.length > 0).length > 0 || '')]"  
                                    ></v-select>
                                </div> 
                               
                            </template>
                            <template v-if="item.htmlControlType.toUpperCase() === 'INPUT'">                              
                               <div v-bind:key="item.code">
                                  <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                  <v-text-field  
                                       :ref="item.code"
                                       :id="item.code"    
                                       :rules="[v=> !item.requiredFlag || (!!v || '')]"                                 
                                       v-model="getCopyControl(item).selectedValues[0]"                                                                      
                                       outlined 
                                       dense>                                     
                                    </v-text-field>                                 
                                </div>
                            </template>
                             <template v-if="item.htmlControlType.toUpperCase() === 'DATE'">
                              
                                <div v-bind:key="item.code">
                                  <v-menu
                                          v-model="dateMenu"
                                          :close-on-content-click="false"
                                          :nudge-right="40"
                                          transition="scale-transition"
                                          offset-y
                                          min-width="auto">
                                          <template v-slot:activator="{ on, attrs }">
                                          <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                          <v-text-field
                                             v-model="getCopyControl(item).selectedValues[0]"                                 
                                             readonly
                                             v-bind="attrs"
                                             v-on="on"                                            
                                             outlined
                                             dense    
                                             :rules="[v=> !item.requiredFlag || (!!v || '')]"                                                                                    
                                          >                                            
                                          </v-text-field>
                                          </template>
                                          <v-date-picker
                                          v-model="getCopyControl(item).selectedValues[0]"
                                          @input="dateMenu = false"                                        
                                          ></v-date-picker>
                                       </v-menu>                                   
                                </div> 
                            </template>
                             <template v-if="item.htmlControlType.toUpperCase() === 'CURRENCY'">
                               <div v-bind:key="item.code">
                                    <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                     <v-currency-field
                                       v-model="getCopyControl(item).selectedValues[0]"                                               
                                       outlined
                                       dense
                                       prefix="$"
                                       :min="0"    
                                       :rules="[v=> !item.requiredFlag || (!!v || '')]"                                  
                                       />                                     
                                                          
                                </div>
                            </template>
                            <template v-if="item.htmlControlType.toUpperCase() === 'NUMBER'">
                                <div v-bind:key="item.code" :class="{ 'is-invisible': !item.visibleFlag }">
                                     <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                     <v-text-field                                      
                                       v-model="getCopyControl(item).selectedValues[0]" 
                                       type="number"                          
                                       outlined 
                                       dense
                                       min="0"
                                       :rules="[v=> !item.requiredFlag || (!!v || '')]"
                                       >                                     
                                    </v-text-field>          
                                </div>
                            </template>
                             <template v-if="item.htmlControlType.toUpperCase() === 'SIN'">
                               <div v-bind:key="item.code">
                                       <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                      <c_sin v-model="getCopyControl(item).selectedValues[0]"
                                      :outlined="true" 
                                      :dense="true"
                                      :isRequired="item.requiredFlag"></c_sin> 
                                </div>
                            </template>
                             <template v-if="item.htmlControlType.toUpperCase() === 'PHONE'">
                                <div v-bind:key="item.code">
                                       <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                      <c_phone v-model="getCopyControl(item).selectedValues[0]"
                                      :outlined="true" 
                                      :dense="true"
                                      :isRequired="item.requiredFlag"></c_phone>    
                                </div>
                            </template>
                             <template v-if="item.htmlControlType.toUpperCase() === 'EMAIL'">
                                <div v-bind:key="item.code">
                                      <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                     <c_email v-model="getCopyControl(item).selectedValues[0]"
                                      :outlined="true" 
                                      :dense="true"
                                      :isRequired="item.requiredFlag"></c_email>
                                </div> 
                            </template>
                            <template v-if="item.htmlControlType.toUpperCase() === 'TEXTAREA'">
                               <div v-bind:key="item.code">
                                     <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                    <v-textarea                                      
                                       v-model="getCopyControl(item).selectedValues[0]" 
                                       rows="5"
                                       maxlength="2000"
                                       outlined 
                                       dense  
                                       :rules="[v=> !item.requiredFlag || (!!v || '')]"                                    
                                       />                               
                               </div>
                            </template>
                             <template v-if="item.htmlControlType.toUpperCase() === 'URL'">
                               <div v-bind:key="item.code">
                                   <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                    <c_url v-model="getCopyControl(item).selectedValues[1]"
                                      :outlined="true"
                                      :dense="true"
                                      :isRequired="item.requiredFlag"></c_url>                             
                               </div>
                            </template>
                            <template v-if="item.htmlControlType.toUpperCase() === 'CHECKBOXLIST'">
                               <div v-bind:key="item.code">
                                  <label :class="{required:item.requiredFlag}">{{item.name}}</label>
                                  <v-list>
                                    <v-list-item  v-for="(valueItem, index) in item.availableValues" :key="valueItem.value">
                                         <v-checkbox v-model="getCopyControl(item).selectedValues[index]" :label="valueItem.label"  
                                                    :value="valueItem.value"     
                                                    dense                                               
                                                    :rules="[v=> !item.requiredFlag || (item.selectedValues.filter(x=>x.length > 0).length > 0 || '')]"  
                                                ></v-checkbox>
                                    </v-list-item>
                                  </v-list>                                  
                               </div>
                             </template>
                             <template v-if="item.htmlControlType.toUpperCase() === 'CHECKBOX'">
                               <div v-bind:key="item.code" >                                 
                                    <v-checkbox                                     
                                       v-model="getCopyControl(item).selectedValues[0]"                                     
                                       outlined 
                                       dense                                      
                                    >
                                      <template v-slot:label>
                                          <label :class="{'required':item.requiredFlag}">{{item.name}}</label>
                                       </template> 
                                    </v-checkbox>       
                                  
                               </div>
                            </template>
                             <template v-if="item.htmlControlType.toUpperCase() === 'RADIOBUTTONLIST'">
                               <div v-bind:key="item.code">
                                    <label :class="{required:item.requiredFlag}">{{item.name}}</label>
                                    <v-radio-group v-model="getCopyControl(item).selectedValues[0]" column>
                                       <v-radio v-for="(valueItem) in item.availableValues" :key="valueItem.value"
                                        :label="valueItem.label"
                                        :value="valueItem.value"
                                       :rules="[v=> !item.requiredFlag || (item.selectedValues.filter(x=>x.length > 0).length > 0 || '')]"
                                       >
                                       </v-radio>
                                    </v-radio-group>                                    
                                </div>
                            </template>
                            <template v-if="item.htmlControlType.toUpperCase() === 'DATEANDTIME'">
                               <div v-bind:key="item.code">
                                    <label :class="{required:item.requiredFlag}">{{item.name}}</label>
                                    <v-datetime-picker label="Select Date & Time" 
                                     v-model="getCopyControl(item).selectedValues[0]"                                   
                                    outlined 
                                    dense                                  
                                    :rules="[v=> !item.requiredFlag || (!!v || '')]"> 
                                     <template slot="dateIcon">
                                          <v-icon>fas fa-calendar</v-icon>
                                          </template>
                                          <template slot="timeIcon">
                                          <v-icon>fas fa-clock</v-icon>
                                          </template>
                                    </v-datetime-picker>                                 
                                </div>                              
                            </template>
                            <template v-if="item.htmlControlType.toUpperCase() === 'POSTALCODE'">
                                <div v-bind:key="item.code" :class="{ 'is-invisible': !item.visibleFlag }">
                                    <label :for="item.code" class="{required:item.requiredFlag}">{{item.name}}</label>
                                      <c_postal_code :AddressID="1" 
                                        :FSA="getCopyControl(item).selectedValues[0]" :LDU="getCopyControl(item).selectedValues[1]"
                                        @OnFSAChange="onFSA(item, $event)"
                                        @OnLDUChange="onLDU(item, $event)"
                                        :outlined="true"
                                        :dense="true"
                                        :isRequired="item.requiredFlag"
                                        />
                               </div>
                            </template>
                            <template v-if="item.htmlControlType.toUpperCase() === 'ADDRESSSEARCH'">
                                <div v-bind:key="item.code" :class="{ 'is-invisible': !item.visibleFlag }">
                                    <label :for="item.code" class="col-form-label" >{{item.name}}</label>                                    
                                    <c_addr_lookup @onSelect="onAddrSelected" :token="token"/>
                               </div>
                            </template>
                             <template v-if="item.code.toUpperCase() === 'EMAILTYPE' || item.code.toUpperCase() === 'PHONETYPE' || item.code.toUpperCase() === 'SOCIALACCOUNTTYPE'">
                                <v-row v-bind:key="item.code">                                     
                                      <v-col cols="3">
                                        <label :for="item.code" class="col-form-label" :class="{required:item.requiredFlag}">{{item.name}}</label>
                                        <v-select     
                                             :id="item.code"
                                             :ref="item.code"                                                                            
                                             v-model="getCopyControl(item).selectedValues[0]"
                                             :items="item.availableValues"                            
                                             item-text="label" item-value="value"                                    
                                             outlined
                                             dense
                                             :rules="[
                                                v => !item.requiredFlag
                                                      || (!!v
                                                      || '')
                                             ]"
                                          ></v-select>
                                        <label class="error--text" v-show="isSubmitted && $v.controls.$each[columnItem].$error">Duplicate</label>
                                      </v-col>
                                      <v-col cols="5">
                                        <label>Value</label>
                                        <c_email v-model="getCopyControl(item).selectedValues[1]"
                                         v-if="item.code.toUpperCase() === 'EMAILTYPE'"
                                          :outlined="true" 
                                          :dense="true" 
                                          :isRequired="item.requiredFlag"
                                         >
                                         </c_email>
                                        <c_phone v-model="getCopyControl(item).selectedValues[1]"
                                           v-if="item.code.toUpperCase() === 'PHONETYPE'"
                                            :outlined="true"
                                            :dense="true"
                                            :isRequired="item.requiredFlag"
                                        ></c_phone>

                                        <c_url name="item.code" 
                                               v-model="getCopyControl(item).selectedValues[1]"
                                               v-if="item.code.toUpperCase() === 'SOCIALACCOUNTTYPE'" 
                                               :outlined="true" 
                                               :dense="true"
                                               :isRequired="item.requiredFlag"/>
                                      </v-col> 
                                       <v-col cols="3" style="padding-top:25px">                                                                                   
                                            <v-btn color="primary" class="mr-2 mt-1" @click="remove(item)" v-show="canRemove(item.code.toUpperCase())">
                                              {{$t('labels.Remove')}}
                                            </v-btn>
                                            <v-btn color="primary" class="mr-2 mt-1" @click="add(item.code.toUpperCase())" v-show="item.lastItem">
                                              {{$t('labels.Add')}}
                                            </v-btn> 
                                       </v-col>

                                </v-row>                                     
                            </template>
                             <template v-if="item.code.toUpperCase() === 'LEADOWNER'">
                               <div v-bind:key="item.code">
                                    <label :for="item.code" :class="{required:item.requiredFlag}">{{item.name}}</label>
                                     <c_owner_list  v-model="getCopyControl(item).selectedValues[0]" 
                                     :outlined="true" 
                                     :dense="true"
                                     :token="token" 
                                     :isRequired="item.requiredFlag"  />  
                               </div>
                            </template>
                          </template>
                      </v-col>
                   </template>
               </v-row>
           </template >
            <!-- {{this.controls}}<br/><br/> -->
           <!-- {{this.selectedFields}}  -->
    </div>

   </template>
<script>
import c_addr_lookup from "./components/addressLookup";
import c_postal_code from "./components/postalcode.vue";
import c_email from "./components/email";
import c_phone from "./components/phone";
import c_url from "./components/url";
import c_sin from "./components/sin";
import c_owner_list from "./components/agentOwnerList"
export default {   
    props:["selectedFields", "numberOfColumns", "formName"],  
    components:{c_addr_lookup, 
    c_postal_code,
    c_email, 
    c_phone, 
    c_url, 
    c_owner_list,
    c_sin},
    data(){
      return{
        dateMenu:false,
        counter:0,
        loadFlag:false,      
        isSubmitted:false,
        token: this.$route.params.token,
        control:{},
        controls:[{
         requiredFlag:false
        }],
        displayOrderControls:[],
        contactControls:[],
        leadId: this.$route.params.leadId, 
        columnsPerRow: [], 
        selectedValues:{},
        money: {
         decimal: ".",
         thousands: ",",
         prefix: "$ ",
         suffix: "",
         precision: 0,
         masked: false
        }
      }
    },   
   computed:{
      columnArray:function(){         
         return Array.from({length: this.columns}, (v, i) => i);
      }
     // columnsPerRow:function(){       
     //    return this.setRowAndColumns();        
     // }
   }, 
   watch:{
     "selectedFields":{
        handler(n){    
               this.controls = JSON.parse(JSON.stringify(n)) ;  
               this.setRowAndColumns();
            }, immediate:true, deep:true
        },
    "numberOfColumns":{
        handler(n){           
           this.columns = n;   
            this.setRowAndColumns();        
        },immediate:true, deep:true
    }
   }, 
   methods:{ 
      getControls(){
         return this.controls;
      },   
      getSelectedValues(code, formNameDD){   
         let key = code + formNameDD;
         let selectedValueCollection = this.selectedValues[key];
         return selectedValueCollection
      },
      groupBy(array, key){
        return array.reduce((result, currentValue) => {    
          (result[currentValue[key]] = result[currentValue[key]] || []).push(
             currentValue
          );
          
          return result;
           }, {});
      },
      canRemove(itemCode){
        return this.controls.filter(x=>x.code === itemCode).length > 1;
      },
      remove(item){
          const index = this.controls.indexOf(item);        
          if (index > -1) { 
               this.controls.splice(index, 1); 
            }
           
           var relatedItems = this.controls.filter(x=>x.code === item.code);
           for(let itemIndex=0; itemIndex < relatedItems.length; itemIndex++){
              relatedItems[itemIndex].lastItem = false; 
           }
           relatedItems[relatedItems.length-1].lastItem = true;
           this.setRowAndColumns() 
      },
      add(itemCode){
         var relatedItems = this.controls.filter(x=>x.code === itemCode);
         var relatedItem = relatedItems[0];
         var clonedRelatedItem = JSON.parse(JSON.stringify(relatedItem))
         clonedRelatedItem.selectedValues = ["", ""]
         clonedRelatedItem.lastItem = true;
         
         for(let itemIndex=0; itemIndex < relatedItems.length; itemIndex++){
            relatedItems[itemIndex].lastItem = false; 
         }

         this.controls.splice(this.controls.indexOf(relatedItems[relatedItems.length -1]) + 1, 0, clonedRelatedItem);
         this.setRowAndColumns() 
      },
      viewLead($event){
         this.$emit("viewLead", $event);        
      },
      dropDownSelectionChanged(item){
        if(item.code === "ADDRESSTYPE"){
          this.addressTypeDD = item.selectedValues[0];         
          this.loadForm(true);
        }
      },
      getControlByCode(code){         
         let filterControl =  this.controls.filter(x=>x.code === code);
         if(filterControl.length > 0){
           return filterControl[0];
         }
         else{
            return null;
         }
         
      },
      getCopyControl(item){      
         return item;   
         //return this.controls.filter(x=>x.code === code && x.formNameDD == formNameDD)[0];
      },
      changeAddressValue(code, value){
           var control =  this.getControlByCode(code) 
           if(control !== null){
              control.selectedValues = []
              control.selectedValues.push(value)
              this.$set(control, 'selectedValues', control.selectedValues)
           } 
      },
      onAddrSelected(addr){     
         let $this = this;       
        setTimeout(() => {   
            $this.changeAddressValue("UNITNO", addr.Unit);               
            $this.changeAddressValue("STREETNO", addr.StreetNumber);  
            $this.changeAddressValue("STREETNAME", addr.StreetName);
            $this.changeAddressValue("STREETTYPE", addr.StreetTypeDD.toString());
            $this.changeAddressValue("STREETDIRECTION", addr.StreetDirectionDD);
            $this.changeAddressValue("CITY", addr.City);
            $this.changeAddressValue("PROVINCE", addr.ProvinceDD.toString());
            $this.changeAddressValue("COUNTRY", addr.CountryTypeDD.toString());
           
            var control =  $this.getControlByCode("POSTALCODE") 
            if(control !== null){
               control.selectedValues = []
               control.selectedValues.push(addr.PostalFsa)
               control.selectedValues.push(addr.PostalLdu)
            } 

           // $this.$refs.STREETDIRECTION[0].$refs.input.dispatchEvent(new Event('select'))      
        }, 100);           
      },
      onFSA(item, n){
        item.selectedValues[0]=n;
      },
      onLDU(item, n){
        item.selectedValues[1]=n;
      },
      numberOfColumnsClass(rowIndex){       
         return  (12/this.columnsPerRow[rowIndex].length)
      },
      setRowAndColumns(){                         
             let columnIndex=0
             let itemArray = []
             let itemIndex = 0;
             let nextControl = null;
             this.columnsPerRow = []            
             if(!this.controls || !this.columns){
                return;
             }
             for(let controlIndex=0; controlIndex<this.controls.length;){               
                itemArray = [];
                var maxColumnlength = this.columns
                if(this.columns.length > this.controls.length){
                    maxColumnlength = this.controls.length
                }
                for(columnIndex=0; columnIndex< maxColumnlength; columnIndex++ ){                  
                   let control = this.controls[itemIndex];
                   if(!control){
                     break;
                   }
                   if(itemIndex < this.controls.length -1){
                      nextControl = this.controls[itemIndex+1];
                   }
                  //  console.log("Control Index: " + controlIndex + " Column Index: " + columnIndex + " item index: " + itemIndex + " Control Code: " + control.code)
                    itemArray.push({
                        index:itemIndex,
                        controls: this.getControl(itemIndex) 
                    });
                     itemIndex++;
                     controlIndex++;
                   if(this.isWiderControl(control) || (nextControl && this.isWiderControl(nextControl)) || itemIndex === this.controls.length){
                       if(!this.isWiderControl(control)){
                          for(let fillindex = columnIndex + 1; fillindex < this.columns; fillindex++){
                             itemArray.push({
                                 index:-1*fillindex*itemIndex,
                                 controls: [] 
                           });
                         }
                       }                       
                       break;
                    }
                }              
                 this.columnsPerRow.push(itemArray)               
             }       
      },
      isWiderControl(x){
         return x.code === 'EMAILTYPE' 
         || x.code === 'PHONETYPE' 
         || x.code === 'SOCIALACCOUNTTYPE'
         || x.code === "ADDRESSTYPE"
         || x.code === "ADDRESSLOOKUP"
         || x.htmlControlType.toUpperCase() === "TEXTAREA"
      },
      hasEmptySelection(values){
         return values.filter(x=>x.label.trim() === "").length > 0;
      },
      getControl(itemIndex){       
        let result =  this.controls[itemIndex];      
        if(!result){
          return [];
        }
        return [result];
       },    
       selectionChanged(control, event){
       },
       pickListChanged(event, control){
          control.selectedValues = event;
       },
       referredByChanged(event, control){
          control.selectedValues[0] = event;
       },
        formatDate:function(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
     },       
    },
   
}
</script>
<style scoped>
.required label:after {
    color: #d00;
    content: "*";
}
 span.required:after,  label.required:after{   
     color: #d00;
     content: "*";
     margin-left: 5px;
     top: 3px;
  }
</style>